// Shared between Community, Corporate, etc
// NOTE: Search for all usages of this file when changed to ensure ?v=XX is bumped where needed

function generateUuid() {
    // Note: crypto.randomUUID() is not available in non-secure context (eg no SSL, most often seen in local development or QA/pre-QA).
    if (typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    const arr = new Uint8Array(16);
    crypto.getRandomValues(arr);
    return [...arr].map(b => b.toString(16).padStart(2, '0')).join('');
}

//region visitdata custom code
const VISIT_DATA_UUID_STORAGE_KEY = 'vsd-uuid-key';
const VISIT_DATA_SESSION_STORAGE_KEY = 'vsd-key';
const THIRTY_MINUTES_MILLIS = 1_000 * 60 * 30;

function shouldUpdateVisitData(existingVisitData, newVisitData) {
    // This tracks if internal links to other pages within the site trigger a "referral"
    const selfReferral = newVisitData.medium === 'referral' && newVisitData.source === visitData.exportedForTesting.getDomain_(window.location.origin);
    if (selfReferral) {
        // Retain the original source/medium data in a self-referral scenario
        newVisitData.source = existingVisitData?.source ?? null;
        newVisitData.medium = existingVisitData?.medium ?? null;
    }
    // We either don't already have a source, or the new source is different and NOT "direct" (eg, they came from some other source)
    return existingVisitData?.source == null || (newVisitData.source !== '(direct)' && newVisitData.source !== existingVisitData.source);
}

function setVisitData() {
    visitData.setOption('cache', false); // No caching via visitData, since we need to update session source in certain scenarios

    const currentVisitData = visitData.get();
    const currentRawData = visitData.rawData();
    const now = Date.now();

    let visitorUuid = localStorage.getItem(VISIT_DATA_UUID_STORAGE_KEY);
    // If we don't have a visitor UUID yet, this is the first tracked visit.
    if (visitorUuid == null) {
        visitorUuid = generateUuid();
        localStorage.setItem(VISIT_DATA_UUID_STORAGE_KEY, visitorUuid);
    }

    const sessionData = JSON.parse(sessionStorage.getItem(VISIT_DATA_SESSION_STORAGE_KEY)) ?? {};
    const dataUpdateRequired = shouldUpdateVisitData(sessionData, currentVisitData);
    if (dataUpdateRequired || sessionData.lastHit == null || (now - sessionData.lastHit > THIRTY_MINUTES_MILLIS)) {
        // Either the first hit or it's been more than thirty minutes or there's a new non-direct source--set a new session UUID
        sessionData.uuid = generateUuid();
        Object.assign(sessionData, currentVisitData);
        sessionData.rawData = currentRawData;
    }
    // Always update the "last hit" time
    sessionData.lastHit = now;

    sessionStorage.setItem(VISIT_DATA_SESSION_STORAGE_KEY, JSON.stringify(sessionData));
    return {
        visitorUuid,
        sessionData,
    };
}

function submitVisitData(visitData, eventType) {
    fetch(new Request('/rapi/visit-data', {
        method: 'POST',
        body: JSON.stringify({...visitData, eventType}),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    }));
}

//endregion